import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ModalBulkDeleteKeywords = ({ isOpen, toggle, selectedCount, isSending, onDelete }) => {
  const { t: translate } = useTranslation();

  return (
    <ModalBulkDeleteKeywordsStyled
      isOpen={isOpen}
      toggle={() => {
        if (!isSending) toggle();
      }}
      centered
      contentClassName="border-0 bg-transparent"
    >
      <div className="modal-box" data-figma-id="15932:8177">
        <ModalHeader data-figma-id="15932:8178">{translate('Delete keywords')}</ModalHeader>
        <ModalBody data-figma-id="15932:8180">
          <p className="m-0">
            {selectedCount === 1
              ? translate(
                  'Are you sure you want to delete the selected keyword? It will no longer be monitored and all ranking history will be lost. This action cannot be undone.',
                )
              : translate(
                  'Are you sure you want to delete the {{count}} selected keywords? They will no longer be monitored and all ranking history will be lost. This action cannot be undone.',
                  { count: selectedCount },
                )}
          </p>
        </ModalBody>
        <ModalFooter data-figma-id="15932:8195">
          <Button color="light" onClick={toggle} disabled={isSending}>
            {translate('Cancel')}
          </Button>
          <Button className="btn-submit" onClick={onDelete} disabled={isSending}>
            {isSending ? (
              <i className="bx bx-loader-alt bx-spin" />
            ) : selectedCount === 1 ? (
              translate('Delete 1 keyword')
            ) : (
              translate('Delete {{count}} keywords', { count: selectedCount })
            )}
          </Button>
        </ModalFooter>
      </div>
    </ModalBulkDeleteKeywordsStyled>
  );
};

const ModalBulkDeleteKeywordsStyled = styled(Modal)`
  max-width: 29.1875rem;

  .modal-box {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 0.375rem;
    background-color: #ffffff;
  }

  .modal-header {
    padding: 1rem 1.5rem;
    border-color: #edf2f7;

    .modal-title {
      color: #343a40;
      font-size: 1.21875rem;
      font-weight: 400;
    }
  }

  .modal-body {
    padding: 1.5rem;
    color: #6b7280;
    line-height: 1.25rem;
  }

  .modal-footer {
    gap: 0.5rem;
    padding: 1rem 1.5rem;
    border-color: #edf2f7;

    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 2.5rem;
      margin: 0;
      padding: 0 1rem;
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.5rem;
    }
  }

  .btn-submit {
    min-width: 10.5rem;
    background-color: #f46a6a;
    border: none;
  }
  .btn-submit:hover {
    background-color: #f23d3d;
  }
`;

ModalBulkDeleteKeywords.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  selectedCount: PropTypes.number,
  isSending: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default ModalBulkDeleteKeywords;
